import axios from 'axios';
import { API_BASE_URL } from '../config/apiConfig';

const authAxios = axios.create({ withCredentials: true });

// 내부 헬퍼: 로그인 응답 데이터를 localStorage에 저장
const persistAuth = (data) => {
  if (!data) return;
  if (data.token) localStorage.setItem('jwt_token', data.token);
  localStorage.setItem('user', JSON.stringify(data));
};

const authService = {
  // 내부 헬퍼: 스토리지 우선순위 처리 (Session > Local)
  getUser: () => {
    const sessionUser = sessionStorage.getItem('user');
    if (sessionUser) {
      return JSON.parse(sessionUser);
    }
    const localUser = localStorage.getItem('user');
    if (localUser) {
      return JSON.parse(localUser);
    }
    return null;
  },

  login: async (username, password, sellerId) => {
    const response = await authAxios.post(`${API_BASE_URL}/auth/login`, { username, password, sellerId });
    persistAuth(response.data);
    return response.data;
  },

  sellerLogin: async (username, password) => {
    const response = await authAxios.post(`${API_BASE_URL}/auth/seller/login`, { username, password });
    persistAuth(response.data);
    return response.data;
  },

  logout: async () => {
    try {
      await authAxios.post(`${API_BASE_URL}/auth/logout`);
    } catch (e) {
      // 서버 오류 시에도 로컬 스토리지는 정리
    }
    localStorage.removeItem('user');
    localStorage.removeItem('jwt_token');
    sessionStorage.removeItem('user');
  },

  signup: async (userData) => {
    return await authAxios.post(`${API_BASE_URL}/auth/signup`, userData);
  },

  // 이메일 중복 확인 (sellerId 전달 시 해당 샵 안에서만 중복 판정)
  checkEmailDuplicate: async (email, sellerId) => {
    const response = await axios.get(`${API_BASE_URL}/auth/check-email`, {
      params: { email, sellerId }
    });
    return response.data;
  },

  // 아이디 중복 확인 (sellerId 전달 시 해당 샵 안에서만 중복 판정)
  checkUsernameDuplicate: async (username, sellerId) => {
    const response = await axios.get(`${API_BASE_URL}/auth/check-username`, {
      params: { username, sellerId }
    });
    return response.data;
  },

  // 휴대폰 번호 중복 확인 (sellerId 전달 시 해당 샵 안에서만 중복 판정)
  checkMobileDuplicate: async (mobile, sellerId) => {
    const response = await axios.get(`${API_BASE_URL}/auth/check-mobile`, {
      params: { mobile, sellerId }
    });
    return response.data;
  },

  // 카카오/네이버 소셜 로그인은 services/oauthApi.js 의 OAuth Hub 흐름으로 통합되었음
  // (linkflower.com/auth/{provider} → 백엔드 /api/auth/oauth/{provider})

  getCurrentUser: () => {
    return authService.getUser();
  },

  getAuthHeader: () => {
    // sessionStorage 우선 (impersonate 판매자 토큰), localStorage 폴백 (일반 로그인 토큰)
    const token = sessionStorage.getItem('jwt_token') || localStorage.getItem('jwt_token');
    if (token) {
      return { Authorization: `Bearer ${token}` };
    }
    return {};
  },

  isAdmin: () => {
    const user = authService.getUser();
    return user && user.role === 'ADMIN';
  },

  isSeller: () => {
    const user = authService.getUser();
    return user && user.role === 'SELLER';
  },

  isAuthenticated: () => {
    return !!authService.getUser();
  },
};

export default authService;

